import { jsxs as d, jsx as e } from "react/jsx-runtime";
function o(l) {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "96",
      height: "40",
      viewBox: "0 0 96 40",
      fill: "#635BFF",
      xmlns: "http://www.w3.org/2000/svg",
      ...l,
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M95.194 20.4663C95.194 13.6969 91.9151 8.35547 85.6481 8.35547C79.3547 8.35547 75.5469 13.6969 75.5469 20.4134C75.5469 28.3728 80.0422 32.3921 86.4943 32.3921C89.641 32.3921 92.0208 31.6781 93.819 30.6733V25.3847C92.0208 26.2838 89.9583 26.8391 87.3404 26.8391C84.7755 26.8391 82.5014 25.94 82.2105 22.8197H95.1411C95.1411 22.476 95.194 21.1009 95.194 20.4663V20.4663ZM82.1328 17.9535C82.1328 14.9655 83.9574 13.7227 85.6233 13.7227C87.2363 13.7227 88.9551 14.9655 88.9551 17.9535H82.1328Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M65.3401 8.35547C62.7487 8.35547 61.0828 9.57185 60.1573 10.418L59.8135 8.77855H53.9961V39.611L60.6068 38.2095L60.6333 30.7262C61.5852 31.4137 62.9867 32.3921 65.3137 32.3921C70.047 32.3921 74.3572 28.5843 74.3572 20.2019C74.3307 12.5334 69.9676 8.35547 65.3401 8.35547H65.3401ZM63.7522 26.5754C62.1921 26.5754 61.2665 26.0201 60.6319 25.3326L60.6055 15.5223C61.293 14.7554 62.2449 14.2266 63.7522 14.2266C66.1585 14.2266 67.8244 16.9237 67.8244 20.3878C67.8244 23.9311 66.1849 26.5754 63.7522 26.5754Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M44.8984 6.79584L51.5356 5.36792V0L44.8984 1.40147V6.79584Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M44.8984 8.80469H51.5356V31.9423H44.8984V8.80469Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M37.7871 10.7614L37.364 8.80458H31.6523V31.9421H38.2631V16.2615C39.8232 14.2254 42.4675 14.5956 43.2872 14.8865V8.80458C42.4411 8.48727 39.3472 7.90552 37.7871 10.7614H37.7871Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.5644 3.06641L18.1124 4.44144L18.0859 25.6222C18.0859 29.5358 21.0211 32.4181 24.9347 32.4181C27.103 32.4181 28.6896 32.0214 29.5622 31.5455V26.1775C28.716 26.5213 24.538 27.7377 24.538 23.8241V14.4369H29.5622V8.80453H24.538L24.5644 3.06641Z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.69006 15.5215C6.69006 14.4902 7.53624 14.0936 8.93771 14.0936C10.9474 14.0936 13.4859 14.7018 15.4956 15.7859V9.57185C13.3008 8.69923 11.1325 8.35547 8.93771 8.35547C3.56979 8.35547 0 11.1584 0 15.8388C0 23.1371 10.0483 21.9736 10.0483 25.1203C10.0483 26.3367 8.9906 26.7333 7.5098 26.7333C5.31503 26.7333 2.51208 25.8342 0.29087 24.6179V30.9113C2.75006 31.969 5.2357 32.4185 7.5098 32.4185C13.0099 32.4185 16.7913 29.6949 16.7913 24.9616C16.7648 17.0816 6.69007 18.4831 6.69007 15.5215L6.69006 15.5215Z"
          }
        )
      ]
    }
  );
}
export {
  o as StripeLogoIcon
};
